import { ReactNode } from 'react';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

interface DisclaimerProps {
    list?: ReactNode[];
}
const Disclaimer = (props: DisclaimerProps) => {
    const { list = [] } = props;
    const { useLang } = useGlobal();
    const { t } = useLang('PoweroceanPlus.Disclaimer');
    return (
        <>
            <div className={styles.disclaimer}>
                {list.map((item, index) => {
                    return (
                        <div className={`item`} key={index}>
                            <div className="desc">{item}</div>
                        </div>
                    );
                })}
                <div className={`item`}>
                    <div className="desc">{t(`text`)}</div>
                </div>
            </div>
        </>
    );
};

export default Disclaimer;
